import { HttpErrorResponse } from '@angular/common/http';
import Utils from '@shared/providers/utils';

export class HttpError extends Error {
  constructor(public response: HttpErrorResponse) {
    super(Utils.formatHttpError(response));
  }
}
